export const CirclesFour = () => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1224_23000" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="4" y="4" width="32" height="32">
      <path
        d="M28.7502 16.7279C31.7417 16.7279 34.1668 14.3027 34.1668 11.3112C34.1668 8.31966 31.7417 5.89453 28.7502 5.89453C25.7586 5.89453 23.3335 8.31966 23.3335 11.3112C23.3335 14.3027 25.7586 16.7279 28.7502 16.7279Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M28.7502 34.2279C31.7417 34.2279 34.1668 31.8027 34.1668 28.8112C34.1668 25.8197 31.7417 23.3945 28.7502 23.3945C25.7586 23.3945 23.3335 25.8197 23.3335 28.8112C23.3335 31.8027 25.7586 34.2279 28.7502 34.2279Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.2502 16.7279C14.2417 16.7279 16.6668 14.3027 16.6668 11.3112C16.6668 8.31966 14.2417 5.89453 11.2502 5.89453C8.25862 5.89453 5.8335 8.31966 5.8335 11.3112C5.8335 14.3027 8.25862 16.7279 11.2502 16.7279Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.2502 34.2279C14.2417 34.2279 16.6668 31.8027 16.6668 28.8112C16.6668 25.8197 14.2417 23.3945 11.2502 23.3945C8.25862 23.3945 5.8335 25.8197 5.8335 28.8112C5.8335 31.8027 8.25862 34.2279 11.2502 34.2279Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0_1224_23000)">
      <path d="M0 0.0605469H40V40.0605H0V0.0605469Z" fill="#BBD0FB" />
    </g>
  </svg>
);
